import BrandList from './BrandList.Container';

export default BrandList;
